/**
 *
 * topic sagas
 *
 */

import {
    put, call, takeLatest, select,
} from 'redux-saga/effects';
import { LOAD_TOPIC } from './topic-constants';
import { topicLoaded, topicLoadingError } from './topic-actions';
import { makeSelectTopicEndpoint } from '../config/runtime-config-selectors';

import request from 'utils/request';

/**
 * Topic data request/response handler
 */
export function* getTopicData(action) {

    const topicId = action.id;

    const urlTemplate = yield select(makeSelectTopicEndpoint());

    const requestURL = urlTemplate ? urlTemplate.replace('{topicId}', `${topicId}`) : '';

    try {

        const data = yield call(request, requestURL);
        yield put(topicLoaded(data));

    } catch (error) {

        yield put(topicLoadingError(error));

    }

}

/**
 * Root saga manages watcher lifecycle
 */
export default function* topicData() {

    // Watches for LOAD_TOPIC actions and calls getListData when one comes in.
    // By using `takeLatest` only the result of the latest API call is applied.
    // It returns task descriptor (just like fork) so we can continue execution
    // It will be cancelled automatically on component unmount
    yield takeLatest(LOAD_TOPIC, getTopicData);

}
